export enum ButtonType {
  Button = 'button',
  Submit = 'submit',
  Reset = 'reset',
}
export enum ButtonStyle {
  Primary = 'btn_primary',
  Secondary = 'btn_secondary',
  OutlinePrimary = 'btn_outline-primary',
  OutlineSecondary = 'btn_outline-secondary',
  OutlineLight = 'btn_outline-light',
  Light = 'btn_light',
  Link = 'btn_link',
  Danger = 'btn_danger',
}
export enum ButtonSize {
  Small = 'btn-sm',
  Medium = '',
  Large = 'btn-lg',
}
